exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ticket-loader[data-v-6e9d7796]{z-index:10;background-color:rgba(0,0,0,0.8)}.ticket-loader-inner-content[data-v-6e9d7796]{top:140px}.ticket-loader-inner-content i[data-v-6e9d7796]{width:143px;height:53px}@media only screen and (min-width: 1025px){.ticket-loader-inner-content[data-v-6e9d7796]{top:215px}.ticket-loader-inner-content i[data-v-6e9d7796]{width:337px;height:125px}}\n", ""]);

// exports
